var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.title != '登录')?_c('PageIndex',{scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('router-view')]},proxy:true}],null,false,489045320)}):[_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }